// src\app\components\layout\CreateRowData.js

import { KIND } from "../../modules/constants"
import { createGovernanceRowData } from "../layout/HomeTables/CreateGovernanceTableData"
import { createLseCompaniesCommitteesRowData } from "../layout/HomeTables/createLseCompaniesCommitteesTableData"
import { createKeyDatesRowData } from "../layout/HomeTables/CreateKeyDatesTableData"
import { createLseCompaniesRowData } from "../layout/HomeTables/CreateLseCompaniesTableData"
import { createLseBoardRowData } from "../layout/HomeTables/CreateBoardTableData"
import { createLsePeopleRowData } from "../layout/HomeTables/CreateLsePeopleTableData"
import { createLsePeopleCommitteesRowData } from "../layout/HomeTables/CreateLsePeopleCommitteesTableData"
import { createLseRolesRowData } from "../layout/HomeTables/CreateLseRolesTableData"
import { createLseRolesCommitteesRowData } from "../layout/HomeTables/CreateLseRolesCommitteesTableData"
import { createLseNewsRowData } from "../layout/HomeTables/CreateLseNewsTableData"
import { createCompaniesRowData, createOfficersRowData } from "../layout/HomeTables/CreateSearchTableData"
import { createFavouriteCompaniesRowData, createFavouritePeopleRowData } from "../layout/HomeTables/CreateFavouritesTableData"
import { createAdvisersRowData } from "../layout/HomeTables/CreateAdvisersTableData"
import { createAdvisersListRowData } from "../layout/HomeTables/CreateAdvisersListTableData"

export const createSearchRowData = props => {
  // console.log('createSearchRowData props:', props)
  switch (props.kind) {
    case KIND.SEARCH.OFFICERS:
    case KIND.SEARCH.DISQUALIFIED:
      return createOfficersRowData(props)

    case KIND.FAVOURITE.COMPANIES:
      return createFavouriteCompaniesRowData(props)

    case KIND.FAVOURITE.PEOPLE:
      return createFavouritePeopleRowData(props)

    case KIND.LSE.COMPANIES.OVERVIEW:
      return createLseCompaniesRowData(props)

    case KIND.LSE.COMPANIES.BOARD:
      return createLseBoardRowData(props)

    case KIND.LSE.COMPANIES.GOVERNANCE:
      return createGovernanceRowData(props)

    case KIND.LSE.COMPANIES.COMMITTEES:
      return createLseCompaniesCommitteesRowData(props)

    case KIND.LSE.COMPANIES.DATES:
      return createKeyDatesRowData(props)

    case KIND.LSE.COMPANIES.ADVISERS:
      return createAdvisersRowData(props)

    case KIND.LSE.ROLES.BOARD:
      return createLseRolesRowData(props)

    case KIND.LSE.ROLES.COMMITTEES:
      return createLseRolesCommitteesRowData(props)

    case KIND.LSE.PEOPLE.BOARD:
      return createLsePeopleRowData(props)

    case KIND.LSE.PEOPLE.COMMITTEES:
      return createLsePeopleCommitteesRowData(props)

    case KIND.LSE.ADVISERS:
      return createAdvisersListRowData(props)

    case KIND.LSE.NEWS:
      return createLseNewsRowData(props)

    case KIND.SEARCH.COMPANIES:
    default:
      return createCompaniesRowData(props)
  }
}